import { Injectable } from '@angular/core';
import { ChartViewDTO } from '../model/chart_view/chart-view-dto';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { QuantiteDossierPortefeuilleDTO } from '../model/quantite-dossier-portefeuille-dto';

@Injectable({
    providedIn: 'root'
  })
export class DashboardGlobalService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    rankingTacheEnRetard() 
    {
        return this._restClientService.load<any[]>('dashboard-global/ranking-tache-en-retard');
    }
    
    quantiteDossierPortefeuille(workflow, debut, fin) 
    {
        return this._restClientService.load<QuantiteDossierPortefeuilleDTO>('dashboard-global/quantite-dossier-portefeuille?workflow='+workflow+'&debut='+debut+'&fin='+fin);
    }
    
}